// 裝置型號 → 產品照（public/products/<asset>.png）。**跟 Android MODEL_TO_DRAWABLE / iOS ProductImage.modelToAsset 同一張表**
//（由 Android 那份產生；新增型號三端一起改）。沒有對照 → 呼叫端用線條圖示（跟手機的 glyph_* 同一組圖）。
// 2026-10-16 John：三端攝影機卡片圖要一致 —— 網頁原本沒有產品照、又先用事件截圖，跟手機不同。
const MODEL_TO_ASSET: Record<string, string> = {
  'LS-2504AC': '2504ac',
  'LS-2505AC': '2505ac',
  'LS-2602AC': '2505ac',
  'LS_2602AC': '2505ac',
  '2602AC': '2505ac',
  'LS-2602': '2505ac',
  'LS-2605': '2504ac',
  'LS-PAC223': '2504ac',
  'LS-PAC006': 'pac006',
  'LS-PAC031': 'pac031',
  'LS-PAC271': 'pac271',
  'LS-PAC372': 'pac372',
  'LS-PAC385': 'pac385',
  'LS-PAC386': 'pac386',
  'LS-PAC462': 'pac462',
  'LS-PAC465': 'pac465',
  'LS-PAC465V2': 'pac465',
  'LS_PC223_4M': 'pc223',
  'LS-PC223': 'pc223',
  'LS_PC230_4M': 'pc230',
  'LS_PC424': 'pac424',
  'LS-PC231': 'pc231',
  'LS-PC232': 'pc232',
  'LS-PC233': 'pc233',
  'PAC122CW41': 'pac122',
  'PAC142CW43': 'pac142',
  'INTERPRO81': 'ipro81',
  'INTERPRO83': 'ipro83',
  'LS-2527': 'ls2527',
  'LS-DOORBELL': 'lsdoorbell',
  'HOME-PANEL': 'panel',
  'IPCAM-PTZ': '2505ac',
  'IPCAM-BASIC': '2504ac',
  'SIM-DOORBELL': 'lsdoorbell',
};

/** model（可能帶 vendor 前綴 livingstyle.ls-2505ac）→ /products/<asset>.png；沒有對照回 null */
export function productImageUrl(model: string | null | undefined): string | null {
  if (!model) return null;
  const key = model.slice(model.lastIndexOf('.') + 1).toUpperCase();
  const asset = MODEL_TO_ASSET[key];
  return asset ? `/products/${asset}.png` : null;
}
